import { ajaxError } from '../ui/feedback.js';
var as_user_id = '';

export function setAsUserId(id) {
    as_user_id = id;
}

export function callAsync(params = {}) {
    if (params.hasOwnProperty('abortVar') && params.abortVar != null) {
        var abort = params.abortVar;
        if (window[abort] != null) {
            window[abort].abort();
            console.log('abort ajax');
            window[abort] = null;
        }
    } else {
        var abort = 'nokill';
    }
    if (
            params.hasOwnProperty('$target') &&
            params.hasOwnProperty('loadingMsg') &&
            params.loadingMsg != null
    ) {
        params.$target.html(params.loadingMsg);
    }
    var ajaxObject = {
        url: params.url + (params.url.indexOf('?') != -1 ? '&' : '?') + 'au=' + as_user_id ,
        type: 'post',
        dataType: 'json',
    };    
    if (params.hasOwnProperty('postData') && params.postData != null) {
        if (typeof params.postData == 'string' && $('#' + params.postData).length) {
            ajaxObject.data = new FormData($('#' + params.postData)[0]);
            ajaxObject.contentType = false;
            ajaxObject.processData = false;
        } else {
            ajaxObject.data = params.postData;
        }
    }
    ajaxObject.success = function (response) {
        if (params.hasOwnProperty('$target') && params.$target != null) {
            // An object is content only when it carries `html`. Anything else is an
            // instruction - {post_ajax_redirect: '...'} above all - and jQuery 4 stringifies
            // whatever it is handed, so writing one to the target puts the literal text
            // "[object Object]" in front of the shopper. (jQuery 3 dropped it silently, which
            // is why this went unnoticed until the 4.0.0 bump.) Non-objects still go straight
            // through: an endpoint answering with a bare JSON string is markup.
            var content = response;
            var isContent = true;
            if (response !== null && typeof response === 'object') {
                isContent = Object.prototype.hasOwnProperty.call(response, 'html');
                content = isContent ? response.html : null;
            }
            if (isContent) {
                if (params.hasOwnProperty('append') && params.append != null) {
                    params.$target.append(content);
                } else {
                    params.$target.html(content);
                }
            }
        }
        if (params.hasOwnProperty('callback') && params.callback != null) {
            if (typeof params.callback === 'string' || params.callback instanceof String) {
                var cfunct = {function: params.callback};
                window[cfunct.function](response, (params.hasOwnProperty('caller') ? params.caller : null));
            } else {
                params.callback(response, (params.hasOwnProperty('caller') ? params.caller : null));
            }
        }
        if (response.hasOwnProperty('post_ajax_redirect')) {
            window.location.replace(response.post_ajax_redirect);
        }
        if (params.hasOwnProperty('disabledBtnId')) {
            $('#' + params.disabledBtnId).prop('disabled', false);
        }
    };
    ajaxObject.error = function (jqXHR, textStatus, errorThrown) {
        if (textStatus === 'abort') {
            return;
        }
        // re-enable whatever the caller disabled, or a failure looks like a hang
        if (params.hasOwnProperty('disabledBtnId')) {
            $('#' + params.disabledBtnId).prop('disabled', false);
        }
        ajaxError('That request could not be completed. Please try again.')(
            jqXHR,
            textStatus,
            errorThrown
        );
    };
    window[abort] = $.ajax(ajaxObject);
}
